/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Header from "../../Common/Navbar";
import Pagination from "../../ListingPage/Pagination";
import { fetchApi } from "../../utlis/axios";
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Lottie from 'lottie-react';
import Loader from '../../animation/Loader.json';
import { FaChevronLeft, FaSearch } from "react-icons/fa";
import { LuFilter } from "react-icons/lu";
import { IoMdClose } from "react-icons/io";
import { MemberRegistration } from "../../RegistrationForms/MemberRegistration";

export const MemberDetailPage = () => {
  const [memberData, setMemberData] = useState([]);
  const { access } = useSelector(state => state.authSlice.userInfo);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [isCheck, setisCheck] = useState(location.state);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen]=useState(false)

  console.log("is Checked", isCheck);

  const [selectedEducation, setSelectedEducation] = useState({
    'high_school': false,
    'college': false,
    'university': false,
  });
  const [selectedMaterial, setSelectedMaterial] = useState({
    'single': false,
    'married': false,
    'committed': false,
  });
  const [selectedMedication, setSelectedMedication] = useState({
    'yes': false,
    'no': false,
  });
  const [selectedwilling, setSelectedWilling] = useState({
    'yes': false,
    'no': false,
  });
  const [selectgender, setSelectGander] = useState({
    'Male': false,
    'Female': false,
  });

  const getMemberData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`member/?search=${searchQuery}`, {
        headers: {
          'Authorization': `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setMemberData(result?.data);
        console.log('result data', result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
    }
  };

  useEffect(() => {
    getMemberData();
  }, [searchQuery, access]);

  const handleTableRowClick = (id) => {
    console.log("Clicked on row with data:", id);
    navigate(`/memberlistingdetail/${id}`);
  };

  const itemsPerPage = 10;
  const totalPages = Math.ceil(memberData.count / itemsPerPage);

  const fetchDataForPage = async (pageNumber) => {
    const newOffset = (pageNumber - 1) * itemsPerPage;
    
    try {
      const selectedEducationList = Object.keys(selectedEducation).filter(
        (status) => selectedEducation[status]
      );

      const selectedMaterialList = Object.keys(selectedMaterial).filter(
        (status) => selectedMaterial[status]
      );

      const selectedMedicationList = Object.keys(selectedMedication)
        .filter((status) => selectedMedication[status])
        .map((status) => (status === 'yes' ? true : false));

      const selectedWillingList = Object.keys(selectedwilling)
        .filter((status) => selectedwilling[status])
        .map((status) => (status === 'yes' ? true : false));

      const selectedgenderList = Object.keys(selectgender).filter(
        (status) => selectgender[status]
      );

      const result = await fetchApi.get(
        `member/?limit=${itemsPerPage}&offset=${newOffset}&page=${pageNumber}&pageSize=${itemsPerPage}&search=${searchQuery}&education_or_qualification=${selectedEducationList.join(',')}&marital_status=${selectedMaterialList.join(',')}&permanent_medication=${selectedMedicationList.join(',')}&willing_to_study=${selectedWillingList.join(',')}&gender=${selectedgenderList.join(',')}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );
  
      return result;
    } catch (error) {
      throw error;
    }
  };


  const handlePageClick = (pageNumber) => {
    console.log("pageNumbber", pageNumber);
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
      setIsLoading(true);
  
      fetchDataForPage(pageNumber)
        .then((result) => {
          if (result.status === 200) {
            setMemberData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };


  const handleEducation = (status) => {
    const updatedStatus = { ...selectedEducation, [status]: !selectedEducation[status] };
    setSelectedEducation(updatedStatus);
    setisCheck(false);
  };

  useEffect(() => {
    if (Object.values(selectedEducation).some((value) => value)) {
      setIsLoading(true);
      fetchDataForPage(currentPage)
        .then((result) => {
          if (result.status === 200) {
            setMemberData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedEducation, currentPage]);

  const handleMaterial = (material) => {
    const updatedStatus = { ...selectedMaterial, [material]: !selectedMaterial[material] };
    setSelectedMaterial(updatedStatus);
    setisCheck(false);
  };

  useEffect(() => {
    if (Object.values(selectedMaterial).some((value) => value)) {
      setIsLoading(true);
      fetchDataForPage(currentPage)
        .then((result) => {
          if (result.status === 200) {
            setMemberData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedMaterial, currentPage]);

  const handleMadication = (medication) => {
    const updatedStatus = { ...selectedMedication, [medication]: !selectedMedication[medication] };
    setSelectedMedication(updatedStatus);
  };

  useEffect(() => {
    if (Object.values(selectedMedication).some((value) => value)) {
      setIsLoading(true);
      fetchDataForPage(currentPage)
        .then((result) => {
          if (result.status === 200) {
            setMemberData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedMedication, currentPage]);

  const handleWilling = (willing) => {
    const updatedStatus = { ...selectedwilling, [willing]: !selectedwilling[willing] };
    setSelectedWilling(updatedStatus);
  };

  useEffect(() => {
    if (Object.values(selectedwilling).some((value) => value)) {
      setIsLoading(true);
      fetchDataForPage(currentPage)
        .then((result) => {
          if (result.status === 200) {
            setMemberData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedwilling, currentPage]);

  const handleGender = (gender) => {
    const updatedStatus = { ...selectgender, [gender]: !selectgender[gender] };
    setSelectGander(updatedStatus);
  };

  useEffect(() => {
    if (Object.values(selectgender).some((value) => value)) {
      setIsLoading(true);
      fetchDataForPage(currentPage)
        .then((result) => {
          if (result.status === 200) {
            setMemberData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectgender, currentPage]);

  const getActiveFilterCount = () => {
    const educationCount = Object.values(selectedEducation).filter(Boolean).length;
    const materialCount = Object.values(selectedMaterial).filter(Boolean).length;
    const medicationCount = Object.values(selectedMedication).filter(Boolean).length;
    const willingCount = Object.values(selectedwilling).filter(Boolean).length;
    const genderCount = Object.values(selectgender).filter(Boolean).length;
    return educationCount + materialCount + medicationCount + willingCount + genderCount;
  };

  // Handle click outside dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowFilterDropdown(false);
      }
    };

    if (showFilterDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilterDropdown]);

  return (
    <>
      <Header parent={'family'}/>
      <button className="w-max p-1 mt-24 sm:ml-[32px] ml-[16px] rounded-full shadow-none bg-primary-green text-white mb-4 " onClick={()=>navigate(-1)}>
<FaChevronLeft size={24}/>
</button>
      <div className="w-full px-[16px] md:px-10 min-h-screen sm:mt-6 mt-[16px] max-w-screen-xl mx-auto">
        {/* Top Section */}
        <div className="flex sm:items-center items-end sm:flex-row flex-col justify-between gap-3 mt-6 md:mb-8 mb-3">
          
          <div className="flex items-center gap-2 sm:w-max w-full">
            {/* Search */}
            <div className="relative flex justify-center border rounded-full sm:py-2 py-[4px] px-2 sm:w-[400px] w-full bg-[#FCFBF7] items-center gap-2">
              <FaSearch className="text-gray sm:w-6 sm:h-6 w-[16px] h-[16px]" />
              <input
                type="search"
                name="search"
                className="w-full outline-none text-gray-600 py-1 px-1"
                placeholder="Search here...."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            {/* Filter Dropdown */}
            <div className="relative" ref={dropdownRef}>
              <button
                className="flex items-center gap-2 sm:p-2.5 p-[4px] bg-transparent shadow-none rounded-xl hover:bg-gray-50 transition-colors"
                style={{ border: '2px solid #d8d8d8' }}
                onClick={() => setShowFilterDropdown(!showFilterDropdown)}
              >
                <LuFilter size={24} className="text-black" />
              </button>

              {/* Filter Dropdown Content */}
              {showFilterDropdown && (
                <div className="absolute top-full sm:left-0 right-[0] mt-2 w-80 bg-white border-[2px] border-[#d8d8d8] rounded-2xl shadow-lg z-10 p-6 max-h-[80vh] overflow-y-auto">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
                    <button
                      onClick={() => setShowFilterDropdown(false)}
                      className="w-max bg-[#d8d8d8] p-1 rounded-full"
                    >
                      <IoMdClose size={20} className="text-black" />
                    </button>
                  </div>

                  {/* Member Education Filters */}
                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">Member Education</h4>
                    <div className="grid grid-cols-2 gap-3">
                      {Object.keys(selectedEducation).map((status) => (
                        <label key={status} className="flex items-center gap-3 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectedEducation[status]}
                            onChange={() => handleEducation(status)}
                            className="w-4 h-4 text-primary-green border-gray-300 rounded focus:ring-primary-green"
                          />
                          <span className="text-sm text-gray-700 capitalize">
                            {status.replace('_', ' ')}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Member Marital Status Filters */}
                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">Member Marital Status</h4>
                    <div className="grid grid-cols-2 gap-3">
                      {Object.keys(selectedMaterial).map((material) => (
                        <label key={material} className="flex items-center gap-3 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectedMaterial[material]}
                            onChange={() => handleMaterial(material)}
                            className="w-4 h-4 text-primary-green border-gray-300 rounded focus:ring-primary-green"
                          />
                          <span className="text-sm text-gray-700 capitalize">{material}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Permanent Medication Filters */}
                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">Permanent Medication</h4>
                    <div className="grid grid-cols-2 gap-3">
                      {Object.keys(selectedMedication).map((medication) => (
                        <label key={medication} className="flex items-center gap-3 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectedMedication[medication]}
                            onChange={() => handleMadication(medication)}
                            className="w-4 h-4 text-primary-green border-gray-300 rounded focus:ring-primary-green"
                          />
                          <span className="text-sm text-gray-700 capitalize">{medication}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Willing to Study Filters */}
                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">Willing to Study</h4>
                    <div className="grid grid-cols-2 gap-3">
                      {Object.keys(selectedwilling).map((willing) => (
                        <label key={willing} className="flex items-center gap-3 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectedwilling[willing]}
                            onChange={() => handleWilling(willing)}
                            className="w-4 h-4 text-primary-green border-gray-300 rounded focus:ring-primary-green"
                          />
                          <span className="text-sm text-gray-700 capitalize">{willing}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Gender Filters */}
                  <div className="mb-4">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">Gender</h4>
                    <div className="grid grid-cols-2 gap-3">
                      {Object.keys(selectgender).map((gender) => (
                        <label key={gender} className="flex items-center gap-3 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectgender[gender]}
                            onChange={() => handleGender(gender)}
                            className="w-4 h-4 text-primary-green border-gray-300 rounded focus:ring-primary-green"
                          />
                          <span className="text-sm text-gray-700 capitalize">{gender}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Register Member Button */}
            <button className="primary-button sm:text-base text-sm font-medium" onClick={()=>setIsOpen(true)}>
              Register Member
            </button>
        </div>

        {/* Table Section */}
        <div className="overflow-x-auto bg-white rounded-[20px] border border-gray-border">
          
          <table className="min-w-full border-collapse">
            <thead>
              <tr className="bg-primary-green text-white text-left">
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Name
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Education
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  {isCheck === true ? "Marital Status" : (Object.values(selectedMaterial).some((value) => value) ? "Marital Status" : "Monthly Income")}
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  {isCheck === true ? "Permanent Medication" : (Object.values(selectedMedication).some((value) => value) ? "Permanent Medication" : "Medical Condition")}
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  Gender
                </th>
                <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                  {Object.values(selectedwilling).some((value) => value) ? "Willing to Study" : "Family"}
                </th>
              </tr>
            </thead>

            <tbody className="font-mulish">
              {isLoading ? (
                <tr>
                  <td colSpan={6} className="h-[60vh]">
                    <div className="flex justify-center items-center h-full w-full">
                      <Lottie
                        loop={true}
                        animationData={Loader}
                        style={{ width: "200px" }}
                        className="auth-sidebar-video"
                      />
                    </div>
                  </td>
                </tr>
              ) : memberData?.results?.length > 0 ? (
                memberData?.results?.map((data, index) => (
                  <tr
                    key={index}
                    className={`cursor-pointer ${
                      index % 2 === 0 ? "bg-white" : "bg-[#219D8014]"
                    } hover:bg-gray-200`}
                    onClick={() => handleTableRowClick(data?.id)}
                  >
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                      {data?.first_name}
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate capitalize">
                      {data?.education_or_qualification?.replace('_', ' ')}
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                      {isCheck === true 
                        ? data?.marital_status 
                        : (Object.values(selectedMaterial).some((value) => value) 
                            ? data?.marital_status 
                            : data?.monthly_income)
                      }
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                      {isCheck === true 
                        ? (data?.permanent_medication ? 'Yes' : 'No')
                        : (Object.values(selectedMedication).some((value) => value) 
                            ? (data?.permanent_medication ? 'Yes' : 'No')
                            : data?.medical_condition)
                      }
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate capitalize">
                      {data?.gender}
                    </td>
                    <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                      {Object.values(selectedwilling).some((value) => value) 
                        ? (data?.willing_to_study ? 'Yes' : 'No')
                        : data?.family?.name
                      }
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="p-4 text-center">
                    No members found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-center items-center mt-6">
            <Pagination
              currentPage={currentPage}
              handlePageClick={handlePageClick}
              totalPages={totalPages}
            />
          </div>
      </div>
      {
        isOpen && <MemberRegistration setShowModal={setIsOpen}/>
      }
    </>
  );
};